import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import useInterval from 'hooks/useInterval'
import { useMqttClient } from 'hooks/useMqttClient'

import { INACTIVITY_TIME, MQTT_COMMAND, VIDEO_INACTIVITY_DELAY } from 'constants/appConstants'

import DebugBar from './components/DebugBar'
import IdleContent from './components/IdleContent'
import PayloadContent from './components/PayloadContent'
import TransitionContent from './components/TransitionContent'
import { getZone } from 'services/screen-service'

const ScreenContent = () => {
  const location = useLocation()
  const { mqttClient, updateScreenId, updateZoneId } = useMqttClient()

  const [payload, setPayload] = useState({})
  const [isPassiveMode, setIsPassiveMode] = useState(true)

  const screenSelectedState = useState(JSON.parse(localStorage.getItem('screenWeb')) || null)
  let [screenSelected] = screenSelectedState
  const [zone, setZone] = useState()

  const [contentType, setContentType] = useState('')
  const [layout, setLayout] = useState({})
  const [counter, setCounter] = useState(0)

  const queryParams = new URLSearchParams(location.search)
  const debug = queryParams.get('debug')
  const debugBool = debug === 'true' || !screenSelected

  const queryScreen = queryParams.get('screen')

  if (queryScreen) {
    screenSelected = { value: queryScreen, label: queryScreen }
    localStorage.setItem('screenWeb', JSON.stringify(screenSelected))
  }

  let passiveTimeout

  const setContentAttributes = ({ contentType, layout }) => {
    setContentType(contentType)
    setLayout(layout)
  }

  const getPlayVideoContentTime = ({ totalTime, currentTime }) =>
    totalTime === null || currentTime === null
      ? INACTIVITY_TIME
      : (totalTime - currentTime) * 1000 + VIDEO_INACTIVITY_DELAY

  const handleMqttMessage = (topic, message) => {
    const objectMessage = JSON.parse(message.toString())
    setPayload(objectMessage)

    const { command } = objectMessage
    const activeCommands = [MQTT_COMMAND.SHOW_CONTENT, MQTT_COMMAND.PLAY, MQTT_COMMAND.PAUSE]
    const isActivePayload = activeCommands.includes(command)

    if (isActivePayload) {
      setIsPassiveMode(false)
      const timeToPassiveMode =
        command === MQTT_COMMAND.PLAY ? getPlayVideoContentTime(objectMessage.data) : INACTIVITY_TIME

      clearTimeout(passiveTimeout)
      passiveTimeout = setTimeout(() => setIsPassiveMode(true), timeToPassiveMode)

      setCounter(timeToPassiveMode / 1000)
    }
  }

  useEffect(() => {
    updateScreenId(screenSelected?.value)
    getZone(screenSelected?.value).then(zone => {
      const zoneId = zone?.data?.data[0]?.documentId
      setZone(zoneId)
      updateZoneId(zoneId)
    })
  }, [screenSelected])

  useEffect(() => {
    if (!mqttClient) {
      return
    }

    mqttClient.on('message', handleMqttMessage)
    return () => mqttClient.removeListener('message', handleMqttMessage)
  }, [mqttClient])

  useInterval(() => {
    counter > 0 && setCounter(count => count - 1)
  }, 1000)

  return (
    <>
      {screenSelected && (
        <TransitionContent currentState={isPassiveMode ? 0 : 1}>
          <IdleContent screenSelected={screenSelected.value} setContentAttributes={setContentAttributes} />
          <PayloadContent payload={payload} setContentAttributes={setContentAttributes} />
        </TransitionContent>
      )}
      <DebugBar
        debugBool={debugBool}
        screenSelectedState={screenSelectedState}
        contentAttributes={{ contentType, layout }}
        isPassiveMode={isPassiveMode}
        countDown={counter}
        zone={zone}
      />
    </>
  )
}

export default ScreenContent
